import { z } from 'zod';
import {
    CakeToOrderIncludedServiceModelSchema,
    CakeToOrderNonIncludedServiceModelSchema,
    CakeToOrderPortionModelSchema,
    CakeToOrderRecommendationModelSchema,
    CakeToOrderSetModelSchema,
} from './components';

export const CakeToOrderModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    description: z.any().optional().nullable(),
    images: z.array(z.object({
        url: z.string(),
    })).optional().nullable(),
    portions: z.array(
        CakeToOrderPortionModelSchema,
    ).optional().nullable(),
    sets: z.array(
        CakeToOrderSetModelSchema,
    ).optional().nullable(),
    includedServices: z.array(
        CakeToOrderIncludedServiceModelSchema,
    ).optional().nullable(),
    nonIncludedServices: z.array(
        CakeToOrderNonIncludedServiceModelSchema,
    ).optional().nullable(),
    recommendations: z.array(
        CakeToOrderRecommendationModelSchema,
    ).optional().nullable(),
});

export type CakeToOrderModel = z.infer<typeof CakeToOrderModelSchema>;
